import {
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { TimelineInfo } from '../shared/timeline-info';
import { InfoType } from '../shared/info-type';
import { DomSanitizer } from '@angular/platform-browser';
import { TimelineEventType } from '../shared/timeline-event-type';
import { EtaInfos } from '../trip-timeline/trip-timeline.component';
import { Moment } from 'moment';
import { DateTimezoneService } from '../shared/date-timezone.service';
import { EtaEmitter } from '../shared/eta-emitter.enum';

@Component({
  selector: 'app-trip-info',
  templateUrl: './trip-info.component.html',
  styleUrls: ['./trip-info.component.scss']
})
export class TripInfoComponent {

  InfoType = InfoType;
  TimelineEventType = TimelineEventType;

  @Input()
  info: TimelineInfo;

  @Input()
  etaInfos: EtaInfos;

  @Input()
  type: TimelineEventType;

  @Input()
  focus: boolean;

  @Input()
  zoom: number;

  @Input()
  distanceUnit: string;

  format = 'LL - LT';

  currentTimeZoneTime1: String;
  currentTimeZoneTime2: String;

  preferredTimeZoneTime1: String;
  preferredTimeZoneTime2: String;

  dateFormat = 'dddd, MMMM D [at] LT (z)';

  protected readonly EtaEmitter = EtaEmitter;

  @HostBinding('style')
  public get valueAsStyle(): any {
    return this.sanitizer.bypassSecurityTrustStyle(`--pos: ${this.info.pos}%`);
  }

  constructor(
    private sanitizer: DomSanitizer,
    private timeZoneService: DateTimezoneService
  ) {
    timeZoneService.defaultTimezone.subscribe(() => {
      this.currentTimeZoneTime1 = this.formatDate(this.timeZoneService.getDefaultTime(this.info?.time1));
      this.currentTimeZoneTime2 = this.formatDate(this.timeZoneService.getDefaultTime(this.info?.time2));
    });
    timeZoneService.tripTimezone.subscribe(() => {
      this.preferredTimeZoneTime1 = this.formatDate(this.timeZoneService.getTripTime(this.info?.time1));
      this.preferredTimeZoneTime2 = this.formatDate(this.timeZoneService.getTripTime(this.info?.time2));
    });
  }

  private formatDate(date: Moment): string {
    return date ? date.format('dddd, MMMM D [at] LT (z)') : null;
  }
}
